export interface IValidateIfEmailExists {
  emailExists: boolean;
  userId: number;
  userName: string;
}

export class ValidateIfEmailExists implements IValidateIfEmailExists {
  emailExists: boolean = false;
  userId: number = 0;
  userName: string = "";
}
